module.exports = __webpack_public_path__ + "img/enrolled-student-8.c8a2bfe0.png";